import DefaultStyle from './DefaultStyle';
import GridStyle from './GridStyle';
import ThumbnailsStyle from './ThumbnailsStyle';

const Style = ({ attributes, setAttributes, updateObject, multipleAttrChange, premiumProps }) => {
    const { layoutType } = attributes;

    const defaultStyleProps = { attributes, setAttributes, updateObject, multipleAttrChange, premiumProps };

    return <div className='bsbGeneralMainArea'>
        <DefaultStyle {...defaultStyleProps} />
        {layoutType === "grid" && <GridStyle {...defaultStyleProps} {...premiumProps} />}
        {layoutType === "thumbnails" && <ThumbnailsStyle {...defaultStyleProps} {...premiumProps} />}
    </div>
}
export default Style;